"use client";

import { useEffect, useRef } from "react";
import {
  trackArticleOpen,
  trackSearch,
  trackThreadOpen,
  trackVisszhangOpen,
} from "@/lib/analytics";

const recentCaptureKeys = new Set<string>();

type AnalyticsBeaconProps =
  | { event: "thread_open"; payload: Parameters<typeof trackThreadOpen>[0] }
  | { event: "article_open"; payload: Parameters<typeof trackArticleOpen>[0] }
  | { event: "visszhang_open"; payload?: Parameters<typeof trackVisszhangOpen>[0] }
  | { event: "search_performed"; payload: Parameters<typeof trackSearch>[0] };

export function AnalyticsEventBeacon(props: AnalyticsBeaconProps) {
  const capturedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const captureKey = JSON.stringify(props);
    if (capturedKeyRef.current === captureKey) return;
    if (recentCaptureKeys.has(captureKey)) return;
    capturedKeyRef.current = captureKey;
    recentCaptureKeys.add(captureKey);
    window.setTimeout(() => recentCaptureKeys.delete(captureKey), 2000);

    if (props.event === "thread_open") trackThreadOpen(props.payload);
    if (props.event === "article_open") trackArticleOpen(props.payload);
    if (props.event === "visszhang_open") trackVisszhangOpen(props.payload);
    if (props.event === "search_performed") trackSearch(props.payload);
  }, [props]);

  return null;
}
